<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-10 16:58:24
 * @FilePath: 
 * @Description: 预约挂号--选择技师页面
-->
<template>
  <div class="select_period_con">
    <div class="product_title">{{ projectInfo.Name }}</div>

    <ul class="period_list_con">
      <li
        v-for="(item, index) in jishiList"
        :key="index"
        :class="{
          active: curPeriodIndex == item.JishiId,
        }"
        @click="handleSetJishi(item.JishiId)"
      >
        <div class="jishi_photo_con">
          <img class="full_img" v-if="item.Image1" :src="item.Image1" alt="" />
          <i
            v-else
            :class="'iconfont ' + (item.SexId == 1 ? 'icon-nan1' : 'icon-nv1')"
          ></i>
        </div>
        <div class="jishi_info_con">
          <div class="c-f">
            <span class="c-ft-28">{{ item.JishiName }}</span>
            <span class="jishi_type_con" v-if="item.JishiLevel">{{
              item.JishiLevel
            }}</span>
          </div>
          <div class="c-ft-22">
            {{ item.Introduction }}
          </div>
        </div>
        <div
          :class="[
            { jishi_status_grey: item.JsState !== '空闲' },
            'jishi_status',
          ]"
        >
          {{ item.JsState }}
        </div>
      </li>
    </ul>
    <!-- <ul class="period_list_con">
      <li
        v-for="(item, index) in jishiList"
        :key="index"
        :class="{
          active: curPeriodIndex == item.Id,
          disabled: item.LeaveNum == 0,
        }"
        @click="handleSetPeriod(item.Id)"
      >
        <div>
          {{ item.PeriodTime }}
        </div>
        <div>
          {{ item.LeaveNum == 0 ? "约满" : "剩余：" + item.LeaveNum }}
        </div>
      </li>
    </ul> -->
    <div class="footer">
      <div class="submit_btn_con">
        <van-button
          color="var(--tc)"
          round
          block
          @click="handleSubmitOrder"
          :loading="isSubmitLoading"
          loading-text="提交中..."
          >确定</van-button
        >
        <!-- <p class="dark-btn" @click="placeOrder"
      v-if="keyBindMode !== 'ManualInputByWaiter' || handCode">{{ wechatPointPayMode === 'CyBillWithPad' ? '呼叫服务员' : '提交订单' }}</p> -->
      </div>
    </div>
  </div>
</template>

<script>
import { handleTimeLocalStorage } from "@/utils";
import { getJishiList } from "@/api/bookRegister";
export default {
  name: "SelectPeriod",
  props: {},
  data() {
    return {
      projectInfo: {
        Name: "",
      },
      curPeriodIndex: 1,
      // dayList: [],
      jishiList: [],

      personNum: 1,
      isSubmitLoading: false,
    };
  },
  components: {},
  created() {},
  mounted() {
    const pointProjectInfo = handleTimeLocalStorage.get("pointProject");
    this.projectInfo = pointProjectInfo;
    this.handleGetJishiList();
  },
  methods: {
    handleGetJishiList() {
      getJishiList({
        VpnId: this.$store.state.vpnId,
        ProductId: this.projectInfo.Id,
      }).then((res) => {
        this.jishiList = res;
      });
    },
    handleSetDayType(type) {
      this.curDayIndex = type;
    },
    handleSetJishi(type) {
      this.curPeriodIndex = type;
    },

    handleSubmitOrder() {
      console.log("提交");
      const jishiItem = this.jishiList.find(
        (item) => item.JishiId == this.curPeriodIndex
      );
      handleTimeLocalStorage.set("pointProject", {
        ...this.projectInfo,
        JishiId: this.curPeriodIndex,
        JishiName: jishiItem ? jishiItem.JishiName : "",
      });
      this.$router.push({
        name: "SelectPeriod",
      });

      // })
      // .catch(() => {
      //   this.isSubmitLoading = false;
      // });
    },
  },
};
</script>
<style scoped lang="scss">
.select_period_con {
  // padding: 24px 32px;
  padding-bottom: 130px;
  .product_title {
    // text-align: center;
    padding: 30px 32px 0;
    font-weight: bold;
    color: #333;
    font-size: 30px;
    background-color: #fff;
  }
}

.period_list_con {
  padding: 32px;
  background-color: #fff;
  li {
    display: flex;
    align-items: center;
    padding: 32px 24px;
    margin-bottom: 12px;
    color: #333;
    background: #f7f7f7;

    border-radius: 8px;
    position: relative;

    &.active {
      // background: #CCA568;

      border: 2px solid #cca568;
      // color: #fff;
    }

    .jishi_photo_con {
      width: 80px;
      height: 80px;
      line-height: 80px;
      border-radius: 50%;
      background: #e7e7e7;
      text-align: center;
      margin-right: 18px;

      .iconfont {
        font-size: 46px;
      }

      img {
        border-radius: 50%;
      }
    }

    .jishi_info_con {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 80px;

      .jishi_type_con {
        padding: 1px 7px;
        border-radius: 4px;
        border: 1px solid #6d3d15;
        color: #6d3d15;
        margin-left: 12px;
        font-size: 22px;
      }
    }

    .jishi_status {
      position: absolute;
      right: 0;
      top: 0;
      width: 100px;
      height: 40px;
      background: #cca568;
      border-radius: 0px 7px 0px 8px;
      text-align: center;
      line-height: 40px;

      &.jishi_status_grey {
        background: #ccc;
      }
    }
  }
}
.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 2;
  width: 100%;
  height: 140px;
  border-top: 1px solid #eee;
  background: #fff;
  box-sizing: border-box;
  padding: 26px 32px;
  .submit_btn_con {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
